/**
 * Base print styles for PrintPreviewDialog.
 *
 * Provides the foundation @media print rules that flatten the MUI Dialog,
 * apply Letter page size with safe margins (18 mm top/bottom reserves space
 * for the browser's native header/footer), and expose utility classes:
 *
 *  • `.noPrint`    — hidden on print
 *  • `.screen-only` — hidden on print (alias)
 *  • `.print-only` — hidden on screen, shown on print
 *  • `#printRoot`  — safe-area padding for the printed content
 *
 * Feature-specific styles can be concatenated after this string.
 */

const printBaseStyles = `
.print-only {
  display: none !important;
}

@media print {
  /* ── Page: Letter with safe margins ── */
  @page {
    size: letter;
    margin: 18mm 12mm 18mm 12mm;
  }

  /* ── Utility classes ── */
  .noPrint,
  .screen-only {
    display: none !important;
  }
  .print-only {
    display: block !important;
  }

  /* ── Hide app shell ── */
  body > *:not(.MuiDialog-root) {
    display: none !important;
  }

  /* ── Flatten MUI Dialog chrome ── */
  .MuiDialog-root {
    position: static !important;
  }
  .MuiBackdrop-root {
    display: none !important;
  }
  .MuiDialog-container {
    display: block !important;
    height: auto !important;
    overflow: visible !important;
  }
  .MuiDialog-paper {
    box-shadow: none !important;
    margin: 0 !important;
    max-height: none !important;
    max-width: none !important;
    width: 100% !important;
    border-radius: 0 !important;
    overflow: visible !important;
  }
  .MuiDialogContent-root {
    overflow: visible !important;
  }

  /* ── Print root safe-area ── */
  #printRoot {
    padding: 2mm 0 0 0 !important;
  }
}
`;

export default printBaseStyles;
